import { useContext } from "react";
import { demoContext } from "./context.demo";
import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

import { setContext } from "@apollo/client/link/context";

import { decodeToken } from "../../helpers";

const authLink = setContext((_, { headers }) => {
  const { token } = useContext(demoContext);

  return {
    headers: {
      ...headers,
      authorization: decodeToken(token) ? `Bearer ${token}` : `Bearer ${token}`,
    },
  };
});

const httpLink = createUploadLink({
  uri: import.meta.env.VITE_GRAPHQL_URI,
});

const additiveLink = from([authLink, httpLink]);

export const client = new ApolloClient({
  ssrMode: typeof window === "undefined",
  cache: new InMemoryCache(),
  link: additiveLink,
});
